import React from 'react';
import { useNavigate } from 'react-router-dom';
import heroImage from '../assets/hero.png';

const translations = {
  de: {
    headline: 'Willkommen bei der modernsten Rollhockey-Anzeigetafel',
    sub: 'Intuitiv. Flexibel. Für deinen Club gemacht.',
    cta: 'Jetzt ausprobieren',
    learn: 'Mehr erfahren',
    heroHeading: 'Verwandle deine Halle in eine professionelle Arena',
    nextGenScoreboard: 'Dein Spiel verdient das beste Scoreboard',
    openScoreboard: 'Kostenlos starten – keine Installation nötig',
    optimizedForChrome: 'Optimiert für Chrome',
  },
  en: {
    headline: 'Welcome to the most advanced rink hockey scoreboard',
    sub: 'Intuitive. Flexible. Made for your club.',
    cta: 'Try now',
    learn: 'Learn more',
    heroHeading: 'Transform your arena into a professional venue',
    nextGenScoreboard: 'Your game deserves the best scoreboard',
    openScoreboard: 'Start for free – no installation required',
    optimizedForChrome: 'Optimized for Chrome',
  }
};

export default function HeroSection({ lang = 'de' }) {
  const t = translations[lang];
  const navigate = useNavigate();
  
  return (
    <div className="flex relative z-0 flex-col justify-center items-start w-full text-base text-center text-white min-h-[800px] overflow-hidden">
      <img
        loading="lazy"
        src={heroImage}
        alt="Rink hockey game in action - players competing on the rink"
        className="object-cover absolute inset-0 w-full h-full"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40" aria-hidden="true" />
      <div className="relative z-10 flex flex-col justify-center items-center w-full max-w-[720px] mx-auto px-4">
        <p className="text-xl mb-4" id="hero-heading">{t.heroHeading}</p>
        <h1 className="text-7xl font-extrabold tracking-tighter leading-[78px] mb-8 max-md:text-4xl max-md:leading-10">
          {t.nextGenScoreboard}
        </h1>
        <button 
          className="flex gap-1 justify-center items-center px-7 py-5 text-black bg-white rounded-lg min-h-[64px] hover:bg-gray-100 transition-colors max-md:px-5"
          onClick={() => navigate('/control')}
          aria-label="Open rink hockey scoreboard control panel"
        >
          <div className="flex flex-col items-center">
            <span className="gap-2">
              {t.openScoreboard}
            </span>
            <span className="gap-2 text-xs opacity-75">
              Optimized for Chrome
            </span>
          </div>
        </button>
      </div>
    </div>
  );
}